import { post, get, queryToObject, replaceUnderLine } from "../libraries/helper";

export const list = (name, query = "") => get(`/${name}`, `${replaceUnderLine(name)}_list`, query != "" ? queryToObject(query) : "");
export const store = (name) => post(`/${name}`, `${replaceUnderLine(name)}_store`);
export const edit = (id, name) => get(`/${name}/${id}`, `${replaceUnderLine(name)}_edit`);
export const update = (id, name) => post(`/${name}/${id}`, `${replaceUnderLine(name)}_update`);
export const destroy = (id, name) => {
    return get(`/${name}/destroy/${id}`, `${replaceUnderLine(name)}_destroy`);
}

export const unpublish = (id, name) => get(`/${name}/unpublish/${id}`, `${replaceUnderLine(name)}_unpublish`);
export const publish = (id, name) => get(`/${name}/publish/${id}`, `${replaceUnderLine(name)}_publish`);

export const active = (id, name) => get(`/${name}/active/${id}`, `${replaceUnderLine(name)}_active`);
export const deactive = (id, name) => get(`/${name}/deactive/${id}`, `${name.replace(/\s/g, '')}_deactive`);

export const upload = (id, name) => post(`/${name}/${id}`, `${replaceUnderLine(name)}_upload`, `upload`);

